export const VI_TRI_PERMISSION_CODES = {
  WEB_BH_VI_TRI_LIST: 'WEB_BH_VI_TRI_LIST',
  WEB_BH_VI_TRI_ADD: 'WEB_BH_VI_TRI_ADD',
  WEB_BH_VI_TRI_EDIT: 'WEB_BH_VI_TRI_EDIT',
  WEB_BH_VI_TRI_DELETE: 'WEB_BH_VI_TRI_DELETE',
  WEB_BH_VI_TRI_IMPORT: 'WEB_BH_VI_TRI_IMPORT',
  WEB_BH_VI_TRI_EXPORT: 'WEB_BH_VI_TRI_EXPORT',
} as const
